import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex)

const store = new vuex.Store({
  //存变量的
  state: {
    a: 1,
    c: 3,
    name: 'name',
    defaultImg: require('@/assets/img/default/product.png'),//商品列表里商品
    defaultbanner: require('@/assets/img/default/banner.png'),//首页轮播
    defaultcjsp: require('@/assets/img/default/cjsp.png'),//首页抽奖
    defaultgwc: require('@/assets/img/default/product-1.png'), //购物车，足迹，收藏
    defaultdp: require('@/assets/img/default/dinapu.png'), //购物车，足迹，收藏

    loginurl:'/',
    
    count: 0
  },
  //对state里面的值进行处理
  getters: {
    b(state) {
      return state.a + 1
    }
  },
  //改变state值
  mutations: {
    SET_A(state, value) {
      state.a = value
    },
    
    increment () {
      this.count++
    },
  },
  //间接改变state
  actions: {
    // action_set_a({ commit }, value) {
    //   commit('SET_A', value)
    // }
    action_set_a(context,value) {
      console.log(context)
      context.commit('SET_A', value)
    }
  },
  modules: {
    user: {
      state: {
        a: 100
      },
      getters: {},
      mutations: {
        SET_Usera(state, value) {
          state.a = value
        }
      },
    },
    app: {
      state: {
        a: 1
      },
      getters: {},
      mutations: {
        SET_Usera2(state, value) {
          state.a = value
        }
      },
    }
  }
})

export default store
